export default {
    Software: {
        getRoute: route("api.software.index", {
            with: ["category"],
        }),
        structure: {
            name: "Name",
            casino_count: "Casino count",
        },
    },
    License: {
        getRoute: route("api.licenses.index", {
            with: ["category"],
        }),
        structure: {
            name: "Name",
            casino_count: "Casino count",
        },
    },
    Country: {
        getRoute: route("api.countries.index", {
            with: ["category"],
        }),
        structure: {
            name: "Name",
            casino_count: "Casino count",
        },
    },
    "Payment Method": {
        getRoute: route("api.paymentMethods.index", {
            with: ["category"],
        }),
        structure: {
            name: "Name",
            deposit_method_count: "Casino deposit count",
            withdrawal_method_count: "Casino withdrawal count",
        },
    },
};
